import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-option-tarification',
    templateUrl: './credit-option-tarification.component.html',
    styleUrls: ['./credit-option-tarification.component.scss'],
    standalone: false
})
export class CreditOptionTarificationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  smoothingFeesDurationRef: any[] = [
    { id: 'AUCUN', label: 'Aucun' },
    { id: 'UN', label: '1 mois' },
    { id: 'TROIS', label: '3 mois' },
    { id: 'SIX', label: '6 mois' },
    { id: 'NEUF', label: '9 mois' },
    { id: 'DOUZE', label: '12 mois' },
  ];
  codeConfiguration: string[] = ['L20', 'L15', 'L10', 'L5', 'L0'];
  isDigitalInsure = true;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.isDigitalInsure = pledge?.products?.[0]?.parameters?.partnerFlux === 'DIGITAL_INSURE';
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    if (this.isDigitalInsure) {
      this.subscriptionFacade.setCommand([
        CommandEnum.COMPUTE_DIGITAL_INSURE_PROFESSION_DETAILS,
      ]);
    }
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
